export default __webpack_public_path__ + "static/media/ic-art-single-apple.c0e49a40.svg";